import { render, staticRenderFns } from "./UploadData.vue?vue&type=template&id=5afd45e8"
import script from "./UploadData.vue?vue&type=script&lang=js"
export * from "./UploadData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports